import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useEffect, useState, useContext, useRef } from 'react';
import { Button, Divider, Paper, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { NamespaceMemberRow } from './namespace-member-row';
import { isError } from '../../extension-registry-types';
import { AddMemberDialog } from './add-namespace-member-dialog';
import { MainContext } from '../../context';
import { EmptyPlaceholder, SectionTitleRow, SettingsSectionTitle } from '../../pages/user/settings/settings-primitives';
export const NamespaceMemberList = props => {
    const { service, user, handleError } = useContext(MainContext);
    const [members, setMembers] = useState([]);
    const [addDialogIsOpen, setAddDialogIsOpen] = useState(false);
    const abortController = useRef(new AbortController());
    useEffect(() => {
        fetchMembers();
    }, [props.namespace]);
    useEffect(() => {
        return () => {
            abortController.current.abort();
        };
    }, []);
    const handleCloseAddDialog = async () => {
        setAddDialogIsOpen(false);
        fetchMembers();
    };
    const handleOpenAddDialog = () => {
        setAddDialogIsOpen(true);
    };
    const fetchMembers = async () => {
        try {
            const membershipList = await service.getNamespaceMembers(abortController.current, props.namespace);
            const members = membershipList.namespaceMemberships;
            setMembers(members);
        }
        catch (err) {
            handleError(err);
        }
    };
    const changeRole = async (membership, role) => {
        try {
            props.setLoadingState(true);
            const endpoint = props.namespace.roleUrl;
            const result = await service.setNamespaceMember(abortController.current, endpoint, membership.user, role);
            if (isError(result)) {
                throw result;
            }
            await fetchMembers();
            props.setLoadingState(false);
        }
        catch (err) {
            handleError(err);
            props.setLoadingState(false);
        }
    };
    if (!user) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(SectionTitleRow, { children: [_jsx(SettingsSectionTitle, { component: 'h3', sx: { m: 0 }, children: "Members" }), _jsx(Button, { variant: 'outlined', startIcon: _jsx(AddIcon, {}), onClick: handleOpenAddDialog, children: "Add member" })] }), members.length ? (_jsx(Paper, { variant: 'outlined', children: _jsx(Stack, { divider: _jsx(Divider, {}), children: members.map(member => (_jsx(NamespaceMemberRow, { member: member, onChangeRole: role => changeRole(member, role), onRemoveUser: () => changeRole(member, 'remove') }, 'nspcmbr-' + member.user.loginName + member.user.provider))) }) })) : (_jsx(EmptyPlaceholder, { children: "There are no members assigned yet." })), _jsx(AddMemberDialog, { members: members, namespace: props.namespace, onClose: handleCloseAddDialog, open: addDialogIsOpen, setLoadingState: props.setLoadingState })] }));
};
//# sourceMappingURL=namespace-member-list.js.map